/**
 * Regras de cores (SLA) por processo, no mesmo formato do endpoint command-center/regras-sla:
 * Estas regras são o fallback quando a API de regras não responde.
 */
const regrasSLADefault = {
  // Aguardando Triagem
  1: {
    Processo: 'Triagem',
    Regras: [
      {
        Criterios: { situacaoAtendimento: 'Aguard. Atendimento', tipoPaciente: 'adulto' },
        Limite: { verde: 3, amarelo: 6, vermelho: null }
      },
      {
        Criterios: { situacaoAtendimento: 'Aguard. Atendimento', tipoPaciente: 'infantil' },
        Limite: { verde: 8, amarelo: 15, vermelho: null }
      },
      {
        Criterios: { situacaoAtendimento: 'Em Atendimento', tipoPaciente: 'adulto' },
        Limite: { verde: 3, amarelo: 6, vermelho: null }
      },
      {
        Criterios: { situacaoAtendimento: 'Em Atendimento', tipoPaciente: 'infantil' },
        Limite: { verde: 8, amarelo: 15, vermelho: null }
      },
    ],
    Limite: null,
  },
  // Aguardando Cadastro
  2: {
    Processo: 'Cadastro',
    Regras: [
      {
        Criterios: { situacaoAtendimento: 'Aguard. Atendimento', tipoPaciente: 'adulto' },
        Limite: { verde: 3, amarelo: 6, vermelho: null }
      },
      {
        Criterios: { situacaoAtendimento: 'Aguard. Atendimento', tipoPaciente: 'infantil' },
        Limite: { verde: 3, amarelo: 6, vermelho: null }
      },
      {
        Criterios: { situacaoAtendimento: 'Em Atendimento', tipoPaciente: 'adulto' },
        Limite: { verde: 10, amarelo: 15, vermelho: null }
      },
      {
        Criterios: { situacaoAtendimento: 'Em Atendimento', tipoPaciente: 'infantil' },
        Limite: { verde: 10, amarelo: 15, vermelho: null }
      },
    ],
    Limite: null,
  },
  // Aguardando Atendimento Médico
  3: {
    Processo: 'Atendimento Médico',
    Regras: [
      {
        Criterios: { classificacaoRisco: 'VERDE' },
        Limite: { verde: 15, amarelo: 20, vermelho: null }
      },
      {
        Criterios: { classificacaoRisco: 'AMARELO' },
        Limite: { verde: 10, amarelo: 15, vermelho: null }
      },
    ],
    Limite: null,
  },
  // Aguardando Reavaliação Médica
  4: {
    Processo: 'Reavaliação Médica',
    Regras: [],
    Limite: { verde: 10, amarelo: 15, vermelho: null },
  },
  // Aguardando Medicação
  5: {
    Processo: 'Medicação',
    Regras: [
      {
        Criterios: { situacaoMedicacao: 'Dispensação' },
        Limite: { verde: 10, amarelo: 15, vermelho: null }
      },
      {
        Criterios: { situacaoMedicacao: 'Checagem' },
        Limite: { verde: 10, amarelo: 18, vermelho: null }
      },
    ],
    Limite: null,
  },
  // Aguardando Exames Laboratoriais
  6: {
    Processo: 'Exames Laboratoriais',
    Regras: [
      {
        Criterios: { tipoExameLaboratorial: 'Coleta C/ Med.' },
        Limite: { verde: 10, amarelo: 15, vermelho: null }
      },
      {
        Criterios: { tipoExameLaboratorial: 'Coleta S/ Med.' },
        Limite: { verde: 7, amarelo: 13, vermelho: null }
      },
      {
        Criterios: { tipoExameLaboratorial: 'Laudo S/ Med.' },
        Limite: { verde: 60, amarelo: null, vermelho: null }
      },
      {
        Criterios: { tipoExameLaboratorial: 'Laudo C/ Med.' },
        Limite: { verde: 60, amarelo: null, vermelho: null }
      },
    ],
    Limite: null,
  },
  // Aguardando Exames de Imagem
  7: {
    Processo: 'Exames de Imagem',
    Regras: [
      {
        Criterios: { tipoExame: 'COLETA', classificacaoRisco: 'VERDE' },
        Limite: { verde: 50, amarelo: null, vermelho: null }
      },
      {
        Criterios: { tipoExame: 'COLETA', classificacaoRisco: 'AMARELO' },
        Limite: { verde: 30, amarelo: null, vermelho: null }
      },
      {
        Criterios: { tipoExame: 'COLETA', classificacaoRisco: 'LARANJA' },
        Limite: { verde: 15, amarelo: null, vermelho: null }
      },
      {
        Criterios: { tipoExame: 'COLETA', classificacaoRisco: 'VERMELHO' },
        Limite: { verde: 10, amarelo: null, vermelho: null }
      },
      {
        Criterios: { tipoExame: 'LAUDO', classificacaoRisco: 'VERDE' },
        Limite: { verde: 120, amarelo: null, vermelho: null }
      },
      {
        Criterios: { tipoExame: 'LAUDO', classificacaoRisco: 'AMARELO' },
        Limite: { verde: 120, amarelo: null, vermelho: null }
      },
      {
        Criterios: { tipoExame: 'LAUDO', classificacaoRisco: 'LARANJA' },
        Limite: { verde: 60, amarelo: null, vermelho: null }
      },
      {
        Criterios: { tipoExame: 'LAUDO', classificacaoRisco: 'VERMELHO' },
        Limite: { verde: 60, amarelo: null, vermelho: null }
      },
    ],
    Limite: null,
  },
  // Aguardando Internação
  8: {
    Processo: 'Internação',
    Regras: [],
    Limite: { verde: 30, amarelo: 40, vermelho: null },
  },
};

export default regrasSLADefault;
